import { jsx } from "react/jsx-runtime";
import TextsmsIcon from "@mui/icons-material/Textsms";
import { validateTidalLicense } from "../../base/index.js";
function Textsms(props) {
  return /* @__PURE__ */ jsx(
    TextsmsIcon,
    {
      "data-testid": "Textsms",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Textsms",
      "data-tidal-icon-meta": "chat,customerService"
    }
  );
}
Textsms.tidalIconMeta = {
  categories: "chat,customerService",
  name: "Textsms"
};
validateTidalLicense();
export {
  Textsms
};
//# sourceMappingURL=Textsms.js.map
